import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { GitOAuthCallbackPage } from '~/components/Credentials/Git/GitOAuthCallbackPage';

// code and error are individually optional so GitLab error responses still parse.
const searchSchema = z.object({
  state: z.string().min(1),
  code: z.string().optional(),
  error: z.string().optional(),
  error_description: z.string().optional(),
});

export const Route = createFileRoute('/callback/git')({
  component: RouteComponent,
  validateSearch: searchSchema,
});

function RouteComponent() {
  const { state } = Route.useSearch();
  return <GitOAuthCallbackPage state={state} />;
}
